import React, { useContext, useRef, useState } from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import { FirebaseContext } from '../../services/firebase/FirebaseContext';
import SolicitorList from './SolicitorList';

const FindFirmForm = ({ onSelect }) => {
    const queryRef = useRef();
    const firebase = useContext(FirebaseContext);
    const findSolicitor = firebase.functions().httpsCallable('findSolicitor');

    const [firms, setFirms] = useState();
    const [criteria, setCriteria] = useState('');
    const [waiting, setWaiting] = useState(false);

    const handleQuery = () => {
        if (!queryRef.current.value) return;
        setCriteria(queryRef.current.value);
        (async () => {
            setWaiting(true)

            const query = {
                SearchText: queryRef.current.value,
                NumberOfResults: 25,
                Skip: 0
            };

            const result = await findSolicitor(JSON.stringify(query));
            const organisations = result.data.Organisations;

            // the order of the results returned is a bit unintuitive due to the lexicographical analysis
            // i.e. things that seem like exact matches to a user don't come first e.g.
            // in a search for MASON BAGGOTT the firm comes about 7th in the results and MASON SOLICITORS LIMITED comes first 

            // so let's grab what appear to be good matches to a user using a regex 
            const rx = new RegExp(criteria, 'i');
            const matches = organisations.filter(org => rx.test(org.PracticeName));
            // and put the rest of the results after those
            setFirms([...matches, ...organisations.filter(org => !matches.find(m => m.Id === org.Id))].slice(0, 10));
            setWaiting(false);
        })();

    };

    const handleKeyPress = ({ key }) => {
        if (/enter/i.test(key)) {
            handleQuery();
        }
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        onKeyPress={handleKeyPress}
                        inputRef={queryRef}
                        defaultValue={criteria}
                        name="queryText"
                        variant="outlined"
                        fullWidth
                        id="queryText"
                        label="Firm Name or SRA Number"
                        autoFocus
                        helperText="You can search for all or any part of your firm name. The SRA search can take a few seconds to complete"
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                {
                    waiting && <LinearProgress style={{ width: '100%', marginTop: '1rem', marginBottom: '1rem' }} />
                }
                {
                    !waiting && <SolicitorList data={firms} onSelect={onSelect} />
                }
            </Grid>
            {
                !waiting &&
                <Button
                    style={{ marginTop: '1rem' }}
                    onClick={handleQuery}
                    fullWidth
                    variant="contained"
                    color="primary"
                >Click here (or press enter) Find your firm
                </Button>
            }
        </div>
    )
}

export default FindFirmForm;